module.exports = __webpack_public_path__ + "static/media/05_DSC8904.dd20ffd4.jpg";